// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import {
  getAnalytics,
  logEvent,
  setAnalyticsCollectionEnabled,
  setUserId,
  setUserProperties,
} from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
const database = getDatabase(firebaseApp);
const storage = getStorage(firebaseApp);
const firestore = getFirestore(firebaseApp);
const analytics = getAnalytics(firebaseApp);

const cloudFunction = getFunctions(firebaseApp, "asia-south1");

if (window.location.host.startsWith("localhost")) {
  setAnalyticsCollectionEnabled(analytics, false);
}

const logGAEvent = (event, eventData, user = {}) => {
  let baseobj = { ...eventData, ...user };
  if (window.currentDivisionData) {
    baseobj["eventID"] = window.currentDivisionData?.currentEventId;
  }
  if (window.currentDivisionData) {
    baseobj["divisionID"] = window.currentDivisionData.id;
  }
  logEvent(analytics, event, { ...baseobj });
};

export {
  firebaseApp,
  auth,
  database,
  storage,
  firestore,
  cloudFunction,
  logGAEvent,
  setUserId,
  setUserProperties,
  analytics,
};
